import script from "./CategoryActionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryActionCard.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryActionCard.vue?vue&type=style&index=0&id=96dec862&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96dec862"]])

export default __exports__